export interface CostTracking {
  inputTokens?: number;
  outputTokens?: number;
  estimatedCost?: number;
}

export interface AuditLog {
  requestId: string;
  orderId?: string;
  createdAt: string;
  updatedAt?: string;
  endpoint: string;
  method: string;
  companyId?: string;
  companyName?: string;
  locale?: string;
  country?: string;
  username?: string;
  aiProvider?: string;
  aiModel?: string;
  requestBody?: string;
  responseBody?: string;
  responseStatus: number;
  costTracking?: CostTracking;
  totalTime?: number;
  aiProcessingTime?: number;
  estimatedCost?: number;
  inputTokens?: number;
  outputTokens?: number;
}

export interface FilterParams {
  // Time filters
  dateRange: {
    start: string; // ISO date string
    end: string;   // ISO date string
  };
  
  // Request filters
  companyId?: string;
  orderId?: string;
  endpoint?: string;
  method?: string;
  username?: string;
  
  // Status filters
  statusFilter?: 'all' | 'success' | 'client_error' | 'server_error';
  specificStatus?: number;
  
  // Performance filters
  minResponseTime?: number; // milliseconds
  maxResponseTime?: number; // milliseconds
  
  // Cost filters
  minCost?: number;
  maxCost?: number;
  aiProvider?: string;
  aiModel?: string;
  
  // Pagination
  limit?: number;
  offset?: number;
}

export interface QueryResponse {
  data: AuditLog[];
  total: number;
  scannedBytes?: number;
  executionTime?: number;
}

export interface ChartData {
  labels: string[];
  datasets: {
    label: string;
    data: number[];
    backgroundColor?: string | string[];
    borderColor?: string | string[];
    borderWidth?: number;
  }[];
}

export interface ErrorRateData {
  date: string;
  totalRequests: number;
  errors: number;
  errorRate: number;
}

export interface CostByCompanyData {
  companyId: string;
  companyName?: string;
  totalRequests: number;
  totalCost: number;
  avgCost: number;
}

export interface PerformanceMetrics {
  endpoint: string;
  method: string;
  requestCount: number;
  avgTimeMs: number;
  medianTimeMs: number;
  p95TimeMs: number;
  maxTimeMs: number;
}

export interface UserActivity {
  username: string;
  totalRequests: number;
  uniqueOrders: number;
  totalCost: number;
}

export interface AIProcessingTimeData {
  requestId: string;
  createdAt: string;
  aiProcessingTime: number;
  endpoint: string;
  responseStatus: number;
}

export interface ReportType {
  id: string;
  name: string;
  description: string;
  icon: string;
}

export const REPORT_TYPES: ReportType[] = [
  {
    id: 'distinct_companies',
    name: 'All Companies',
    description: 'List all company IDs with request counts',
    icon: '🏢'
  },
  {
    id: 'distinct_usernames',
    name: 'All Users',
    description: 'List all usernames with activity stats',
    icon: '👤'
  },
  {
    id: 'error_rate',
    name: 'Error Rate',
    description: 'Error trends over time',
    icon: '📊'
  },
  {
    id: 'cost_analysis',
    name: 'Cost Analysis',
    description: 'Costs by company and AI model',
    icon: '💰'
  },
  {
    id: 'performance',
    name: 'Performance',
    description: 'Response time distribution',
    icon: '⚡'
  }
];

